/*
 * Calmont Mega-Menü mobil (Ebene 2): Chips filtern die Produktliste im Menü, statt sofort zu navigieren.
 * - Chip-Links auf dieselbe Kollektion (Filter-Parameter oder Tag-Pfad) werden im Menü angewendet,
 *   je Gruppe ein aktiver Chip, Gruppen werden kombiniert. Nochmal tippen hebt die Auswahl auf.
 * - Chips auf Produkte oder andere Kollektionen öffnen die Seite wie bisher.
 * - Der Link „Alle … ansehen“ übernimmt die gewählten Filter und zeigt die passende Anzahl.
 * Daten: Section Rendering API mit sections/cal-mega-results.liquid.
 */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const LOCALE = /^\/[a-z]{2}(-[a-z]{2})?(?=\/)/i;

  // Zerlegt einen Chip-Link: Kollektion, Tag, Filter-Parameter (sort_by bleibt erhalten)
  const parse = (href) => {
    let u; try { u = new URL(href, location.origin); } catch (e) { return null; }
    if (u.origin !== location.origin && !/calmont\.de$|myshopify\.com$/.test(u.hostname)) return null;
    const path = decodeURIComponent(u.pathname).replace(LOCALE, '');
    const m = path.match(/^\/collections\/([^/]+)(?:\/([^/]+))?\/?$/);
    if (!m) return null;
    const params = [...u.searchParams.entries()].filter(([k]) => k.startsWith('filter.') || k === 'sort_by');
    return { col: m[1], tag: m[2] || '', params };
  };

  const build = (col, sel) => {
    let tag = ''; const q = new URLSearchParams();
    sel.forEach((f) => {
      if (f.tag) tag = tag ? tag + '+' + f.tag : f.tag;
      f.params.forEach(([k, v]) => { if (k === 'sort_by') q.set(k, v); else q.append(k, v); });
    });
    const path = root.replace(/\/$/, '') + '/collections/' + col + (tag ? '/' + encodeURIComponent(tag).replace(/%2B/g, '+') : '');
    const qs = q.toString();
    return path + (qs ? '?' + qs : '');
  };

  // Zustand je Menü-Ebene (Horizon kann den Drawer neu aufbauen, daher per Delegation statt fester Bindung)
  const states = new WeakMap();
  const state = (box) => {
    let st = states.get(box);
    if (st) return st;
    const items = box.querySelector('[data-mmo-items]'); const all = box.querySelector('[data-mmo-all]');
    st = { sel: new Map(), items, all, original: items ? items.innerHTML : '', allHref: all ? all.getAttribute('href') : '', allHtml: all ? all.innerHTML : '', ctl: null };
    states.set(box, st);
    return st;
  };
  // Chip einer Gruppe zuordnen; null = normaler Link
  const chipOf = (box, a) => {
    const col = box.dataset.mmoCol; if (!col) return null;
    const f = parse(a.getAttribute('href') || '');
    if (!f || f.col !== col) return null;
    const groups = [...box.querySelectorAll('.cal-mmo__chips')];
    const g = groups.indexOf(a.closest('.cal-mmo__chips'));
    return g < 0 ? null : { g: String(g), f };
  };

  const apply = async (box) => {
    const st = state(box); const col = box.dataset.mmoCol;
    box.querySelectorAll('.cal-mmo__chips a[aria-pressed]').forEach((x) => x.setAttribute('aria-pressed', 'false'));
    st.sel.forEach(({ a }) => a.setAttribute('aria-pressed', 'true'));
    const fs = [...st.sel.values()].map((x) => x.f);
    const active = fs.filter((f) => f.tag || f.params.some(([k]) => k !== 'sort_by'));
    const url = build(col, fs);
    if (!active.length) {
      if (st.items) st.items.innerHTML = st.original;
      if (st.all) { st.all.setAttribute('href', st.allHref); st.all.innerHTML = st.allHtml; }
      box.classList.remove('is-filtered');
      return;
    }
    box.classList.add('is-filtered', 'is-loading');
    if (st.ctl) st.ctl.abort(); st.ctl = new AbortController();
    try {
      const r = await fetch(url + (url.includes('?') ? '&' : '?') + 'section_id=cal-mega-results', { signal: st.ctl.signal });
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const res = doc.querySelector('[data-mmo-res]');
      const n = res ? +res.dataset.count || 0 : 0;
      if (st.items) st.items.innerHTML = res && res.children.length ? res.innerHTML : '<p class="cal-mmo__empty">Keine passenden Produkte. Wähle einen anderen Filter.</p>';
      if (st.all) {
        st.all.setAttribute('href', url);
        const arr = st.all.querySelector('.cal-mm__arr');
        st.all.textContent = n === 1 ? '1 passendes Produkt ansehen' : n + ' passende Produkte ansehen';
        if (arr) st.all.append(arr);
      }
    } catch (e) {
      if (e.name !== 'AbortError') location.href = url;
    }
    box.classList.remove('is-loading');
  };

  document.addEventListener('click', (e) => {
    const a = e.target.closest('.cal-mmo .cal-mmo__chips a'); if (!a) return;
    const box = a.closest('[data-mmo]'); if (!box) return;
    const c = chipOf(box, a); if (!c) return;
    e.preventDefault();
    const st = state(box);
    const cur = st.sel.get(c.g);
    if (cur && cur.a === a) st.sel.delete(c.g); else st.sel.set(c.g, { a, f: c.f });
    a.setAttribute('aria-pressed', 'true');
    apply(box);
  }, true);
})();

/* Desktop: „… weitere anzeigen“ in langen Gruppen */
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-mm-more]'); if (!b) return;
  e.preventDefault(); e.stopPropagation();
  const ul = b.closest('.cal-mm__gl'); const open = ul.classList.toggle('is-collapsed') === false;
  if (!b.dataset.more) b.dataset.more = b.textContent;
  b.textContent = open ? b.dataset.less : b.dataset.more;
  b.setAttribute('aria-expanded', String(open));
});
